import type { RecruiterOutcome } from '../services/api'

// MWA-356 — the order the manage-recruiters lambda sorts by (recruiterRules
// sortOutcomes): newest first by when it happened, then by when it was logged,
// so a backdated reply lands where it belongs rather than on top.
export function sortRecruiterOutcomes(outcomes?: RecruiterOutcome[] | null): RecruiterOutcome[] {
  return (outcomes || []).slice().sort((a, b) => {
    const byOccurred = (b.occurredAt || '').localeCompare(a.occurredAt || '')
    return byOccurred !== 0 ? byOccurred : (b.createdAt || '').localeCompare(a.createdAt || '')
  })
}

export function latestRecruiterOutcome(outcomes?: RecruiterOutcome[] | null): RecruiterOutcome | null {
  return sortRecruiterOutcomes(outcomes)[0] ?? null
}

/**
 * A date-only choice sent as local noon, the same convention the contact
 * interaction log uses, so it never lands on the previous day once converted
 * to UTC for anyone west of the meridian.
 */
export function outcomeDateToIso(ymd: string): string {
  return new Date(`${ymd}T12:00:00`).toISOString()
}

/** The inverse, for editing a stored outcome in a date input. */
export function isoToLocalYmd(iso: string): string {
  const d = new Date(iso)
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}
